import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import Debug from 'debug';

import Modal from '../Modal';

import styles from './index.sass';

const debug = Debug('delectable');

class Alert extends React.Component {
  static propTypes = {
    title             : React.PropTypes.string.isRequired,
    body              : React.PropTypes.node,
    textarea          : React.PropTypes.object,
    confirmButtonText : React.PropTypes.string,
    hideCancelButton  : React.PropTypes.bool,
    onCancel          : React.PropTypes.func.isRequired,
    onConfirm         : React.PropTypes.func.isRequired
  };

  static defaultProps = {
    confirmButtonText : 'Confirm',
    hideCancelButton  : false
  };

  constructor(props) {
    if(!props.body && !props.textarea) {throw new Error('Must have body or textarea specified.');}
    super(props);
    let body = props.body;
    if(props.textarea) {
      let textareaProps = _.extend({
        className     : styles.textarea,
        placeholder   : '',
        onChange      : this.handleOnChangeTextarea.bind(this),
        required      : false,
        autoFocus     : true
      }, props.textarea);
      body = <textarea {...textareaProps} />;
    }
    this.state = {
      textareaValue: '',
      body: body
    };
  }

  componentWillReceiveProps(nextProps) {
    if(!nextProps.body) {
      return;
    }
    let body = nextProps.body;
    this.setState({
      body: body
    });
  }

  handleOnChangeTextarea(e) {
    this.setState({textareaValue: e.target.value});
  }

  handleOnCloseModal(e) {
    this.props.onCancel();
  }

  handleOnClickConfirmButton(e) {
    if(this.props.textarea && this.props.textarea.required && !this.state.textareaValue) {return null;}
    this.props.onConfirm(this.state.textareaValue);
  }

  handleOnClickCancelButton(e) {
    this.props.onCancel();
  }

  renderCancelButton() {
    if(this.props.hideCancelButton) {return null;}
    return <button className={styles.cancelButton} onClick={this.handleOnClickCancelButton.bind(this)}>Cancel</button>;
  }

  render() {
    let modalProps = {
      onClose : this.handleOnCloseModal.bind(this)
    };
    let confirmButtonProps = {
      className : styles.confirmButton,
      onClick   : this.handleOnClickConfirmButton.bind(this),
      style     : {backgroundColor: (this.props.confirmButtonColor ? this.props.confirmButtonColor : null)}
    };
    let bodyClassName = this.props.textarea ? styles.bodyWithTextarea : styles.body;

    return (
      <Modal {...modalProps}>
        <div className={styles.alert}>
          <h2 className={styles.title}>{this.props.title}</h2>
          <div className={bodyClassName}>{this.state.body}</div>
          <div className={styles.buttonContainer}>
            <button {...confirmButtonProps}>{this.props.confirmButtonText}</button>
            {this.renderCancelButton()}
          </div>
        </div>
      </Modal>
    );
  }
}

export default Alert;



// WEBPACK FOOTER //
// banquet/components/Alert/index.js